import { defaultHttpClient } from '../../httpClient';
import type { BeautyQueriesResponse } from '../types';

// 뷰티 추천 검색어
export const getBeautyQueries = async () => {
  return defaultHttpClient
    .request<BeautyQueriesResponse>({
      method: 'GET',
      url: '/api/v2/search/beauty-queries/',
    })
    .then(result => result.data);
};
